export { ModernSlaveryActTransparencyStatement } from './ModernSlaveryActTransparencyStatement';
